

exports.__esModule = true;
exports["default"] = void 0;
var _index = require("squid/index");
require("xo-ui-components/src/floating-label/directive");
require("./styles");
var _template = _interopRequireDefault(require("./template"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = _index.$Component.extend('$xoGenderType', {
  tag: 'xo-gender-type',
  template: _template["default"],
  props: {
    user: {
      type: 'var',
      required: false
    }
  }
});
_index.$Component;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-form-components/src/gender-type/directive.js
// module id = ../node_modules/xo-form-components/src/gender-type/directive.js
// module chunks = 0